import React, { Component, useState } from 'react';
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, ListItemSecondaryAction } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { TimeIcon, BackIcon, MopedIcon, PlaceIcon, HourglassIcon, DeliveryIcon } from '../../components/icons'
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import Divider from '../../components/Divider'
import { formatTimeFrEpoch } from '../../utils/util';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlatList from 'flatlist-react';
import { getCurrency, getLogo } from '../../utils/common';
import { getOrderCache } from '../../utils/order_cache';
const styles = theme => ({
    content: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',
        [theme.breakpoints.down('md')]:{
            width: '54%'
        },
        [theme.breakpoints.down('sm')]:{
            width: '63%'
        },
        [theme.breakpoints.down('xs')]:{
            width: '81%'
        }
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    item_image: {
        width: theme.spacing(9),
        height: theme.spacing(9),
        objectFit: 'containt',
        borderRadius: theme.spacing(9),
    },
    item_image_container: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    listItem: {
        marginTop: theme.spacing(7)
    },
    item: {
        margin: theme.spacing(5, 0, 5, 0)
    },
    item_icon_container: {
        // marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
})

function OrderResultView(props) {
    const getComponent = (items) =>{
        var componentStr = '';
        items.forEach(item => {
            componentStr = componentStr + item.name + ", ";
        });
        if (componentStr) {
            componentStr = componentStr.substr(0, componentStr.length - 2);
        }
        return componentStr;
    }
    const getVariant = (items) =>{
        var variantStr = '';
        items.forEach(item => {
            variantStr = variantStr + item.value + ", ";
        });
        if (variantStr) {
            variantStr = variantStr.substr(0, variantStr.length - 2);
        }
        return variantStr;
    }
    const { classes, t, open, onClose, carts, estimate_order_result, delivery_address, pick_up_store, order_type, order_result } = props;
    const currency = getCurrency();
    //console.log("order_result:", order_result);
    var keyDates = order_result.key_dates;
    var stringsReady = order_type === 'DELIVERY' ? t('expected_delivery_time') : t('expected_pickup_time');
    if (keyDates) {
        var time_to_deliver = keyDates.estimated_fulfillement_in ? keyDates.estimated_fulfillement_in : "";
        if (time_to_deliver) {
            time_to_deliver = time_to_deliver + " " + (keyDates.estimated_fulfillment_UOT ? keyDates.estimated_fulfillment_UOT : "");
        }
        var estimateCompleted = order_type === 'DELIVERY' ? keyDates.estimated_fulfillement : keyDates.estimated_fulfillement;
        stringsReady = stringsReady + " " + formatTimeFrEpoch(estimateCompleted) + " (" + time_to_deliver + "S )"
    }
    var deleveryItem = null;
    if (estimate_order_result && estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.line_items && estimate_order_result.invoice_estimate.line_items.length > 1) {
        deleveryItem = dataUtil.getDeliveryItem(estimate_order_result.invoice_estimate.line_items);
    }
    var estimated_delivery = estimate_order_result&&estimate_order_result.order_estimate && estimate_order_result.order_estimate.estimated_delivery ? estimate_order_result.order_estimate.estimated_delivery : null;
    
    //var pickup_address = order_result.fulfilled_by&&order_result.fulfilled_by.address&&order_result.fulfilled_by.address.address_line_1?order_result.fulfilled_by.address.address_line_1:(pick_up_store.address?pick_up_store.address.address_line_1:'')
    var pickup_address = order_result.fulfilled_by&&order_result.fulfilled_by.address ? order_result.fulfilled_by.address.address_line_1
    + (order_result.fulfilled_by.address.town_city ? ', ' + order_result.fulfilled_by.address.town_city : '')
    + (order_result.fulfilled_by.address.state_province_county ? ', ' + order_result.fulfilled_by.address.state_province_county : '')
    + (order_result.fulfilled_by.address.postal_code ? ', ' + order_result.fulfilled_by.address.postal_code : '')
    : ''
    var order_summary = dataUtil.getOrderSummary(estimate_order_result);
    console.log("AAAA order_summary: ", order_summary)
    return (
        <DrawerCustom large open={open} onClose={onClose} title={t("order_placed")}>
            <Grid xs={12} item>
                
                <Grid xs={12} item className={classes.content}>
                    <Grid xs={12} item container direction='row' >
                        {order_type != 'DIRECT_SALE' && <Grid xs={6} item>
                            <Typo color="default" variant='description'>{order_type === 'DELIVERY' ? t("delivery_from") : t("take_away_from")}</Typo>
                            <Typo mg_top_xs color="onPrimary" variant='body2'>{order_type === 'DELIVERY' ? delivery_address.address_line_1 : pick_up_store.name}</Typo>
                        </Grid>}
                        <Grid xs={1} item />
                        <Grid xs={order_type != 'DIRECT_SALE' ? 5 : 12} item>
                            <Typo color="default" variant='description'>{t("order_number")}</Typo>
                            <Typo mg_top_xs color="onPrimary" variant='body2'>{order_result.number}</Typo>
                        </Grid>
                    </Grid>
                    {order_type != 'DIRECT_SALE' && <Grid xs={12} item container direction='row' style={{marginTop:8}}>
                        <Grid xs={6} item>
                            <Typo color="default" variant='description'>{order_type === 'DELIVERY' ? t("To be fulfilled by") : t("Address")}</Typo>
                            <Typo mg_top_xs color="onPrimary" variant='body2'>{order_type === 'DELIVERY' ? order_result.fulfilled_by.name :  pickup_address}</Typo>
                        </Grid>
                        <Grid xs={1} item />
                        <Grid xs={5} item>
                            <Typo color="default" variant='description'>{t("Phone Number")}</Typo>
                            <Typo mg_top_xs color="onPrimary" variant='body2'>{order_result.fulfilled_by.phone}</Typo>
                        </Grid>
                    </Grid>}
                    {estimated_delivery && order_type != 'DIRECT_SALE' &&<Grid xs={12} item container direction='row' className={classes.row}>
                        <HourglassIcon /><Typo mg_left_sm color="default" variant='description'>{stringsReady}</Typo>
                    </Grid>}
                    {carts && carts.length > 0 && <InfiniteScroll  dataLength={carts.length} height={'66vh'}>
                    <Grid xs={12} item className={classes.listItem}>
                        <OrderItem items={carts} classes={classes} currency={currency} getVariant = {getVariant} getComponent={getComponent}/>
                        {deleveryItem && <Grid xs={12} item container direction="row" className={classes.item} alignItems='center'>
                            <Grid xs={2} item>
                                <div className={classes.item_icon_container}>
                                    <DeliveryIcon />
                                </div>
                            </Grid>
                            <Grid xs={1} item container />
                            <Grid xs={6} item>
                                <Typo color="onPrimary" variant='body2'>{deleveryItem.product.name}</Typo>
                            </Grid>
                            <Grid xs={3} item container justify='flex-end'>
                                <Typo color="onPrimary" variant='body2'>{currency}{deleveryItem.unit_price ? deleveryItem.unit_price.toFixed(2) : "0.00"}</Typo>
                            </Grid>
                        </Grid>}
                    </Grid>
                    <Grid xs={12} item container direction="row" alignItems="flex-end" className={classes.row}>
                            <Grid xs={6} item>
                                <Typo mg_top_sm variant='body2' color='onPrimary'>{t('total')}:</Typo>
                            </Grid>
                            <Grid xs={6} item container justify='flex-end'>
                                <Typo mg_top_sm variant='h3' color='onPrimary'>{currency}{order_summary.subTotalAmount ? order_summary.subTotalAmount.toFixed(2) : "0.00"}</Typo>
                            </Grid>
                    </Grid>
                    </InfiniteScroll>}
                </Grid>
                
                <Grid xs={12} item className={classes.footer}>

                    <ButtonCustom fullWidth color='primary' onClick={onClose}>{t('btn_done')}</ButtonCustom>
                </Grid>
            </Grid>

        </DrawerCustom>
    )
}
function OrderItem(props) {
    var classes = props.classes;
    return <FlatList
        list={props.items}
        renderItem={(item) =>
            <Grid xs={12} item container direction="row" className={classes.item} alignItems='center'>
                <Grid xs={2} item>
                    <div className={classes.item_image_container}>
                        <ItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.product_item)} />
                    </div>
                </Grid>
                <Grid xs={1} item container>
                    <Typo color="default" variant='body2'>{item.quantity}x</Typo>
                </Grid>
                <Grid xs={6} item>
                    <Grid xs={12} item>
                        <Typo color="onPrimary" variant='body2'>{item.name}</Typo>
                    </Grid>
                    {item.variant_selected && <Grid xs={12} item><Typo variant='description' color='onPrimary'>{props.getVariant(item.variant_selected)}</Typo></Grid>}
                    {item.components && <Grid xs={12} item><Typo color="default" variant='description'>{props.getComponent(item.components)}</Typo></Grid>}
                </Grid>
                <Grid xs={3} item container justify='flex-end'>
                    <Typo color="onPrimary" variant='body2'>{props.currency}{item.totalAmount.toFixed(2)}</Typo>
                </Grid>
            </Grid>
        }
    />
}

function ItemImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url} />
    } return <img className={props.classes.item_image} src={getLogo()} />;
}
export default withStyles(styles)(withTranslation()(OrderResultView))